module.exports = __webpack_public_path__ + "img/US_FoodGatherRate_ua.a1a86c86.webp";